<template>
    <el-upload
        class="avatar-uploader"
        :action="$config.apiBaseUrl + '/upload-img'"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :on-error="errorUpload"
        :show-file-list="false">
        <div v-if="imgUrl" class="avatar-box">
            <img :src="imgUrl" class="avatar" alt="" />
            <div class="shade"></div>
            <div class="content">
                <em class="el-icon-refresh-left"></em>
                <div class="upload-size">{{ size }}</div>
            </div>
        </div>
        <div class="upload" v-else>
            <em class="el-icon-plus avatar-uploader-icon"></em>
            <div class="upload-size">{{ size }}</div>
        </div>
    </el-upload>
</template>

<script>
import {mapState} from  'vuex';
export default {
    name: "sdkUpload",
    props: {
        value: {
            type: String,
            default: ''
        },
        size: '',
        formatlimit: '',
    },
    data() {
        return {
            imgUrl: ''
        }
    },
    watch: {
        value: {
            handler(val) {
                this.imgUrl = val;
            },
            immediate: true
        }
    },
    computed: {
        ...mapState(['$config'])
    },
    methods: {
        handleSuccess(file) {
            this.$emit('input', file.fileurl || '');
        },
        beforeUpload(file) {

            if(this.$props.formatlimit === 'png') {
                const fileSuffix = ['image/png'].includes(file.type);
                if (!fileSuffix) {
                    this.$message({
                        message: '上传格式错误，只支持png格式！',
                        type: 'error',
                        showClose: true
                    });
                    return false;
                }
            }
            else if (this.$props.formatlimit === 'jpg') {
                const fileSuffix = ['image/jpeg'].includes(file.type);
                if (!fileSuffix) {
                    this.$message({
                        message: '上传格式错误，只支持jpg格式！',
                        type: 'error',
                        showClose: true
                    });
                    return false;
                }
            } else {
                const fileSuffix = ['image/jpeg', 'image/png'].includes(file.type);
                if (!fileSuffix) {
                    this.$message({
                        message: '上传格式错误，只支持png/jpg格式！',
                        type: 'error',
                        showClose: true
                    });
                    return false;
                }
            }

        },
        errorUpload() {
            this.$alert('上传失败！', '提示')
        }
    }
}
</script>

<style lang="scss">

.upload-size{
    color: #8c939d;
}
.avatar-uploader-icon {
    font-size: 40px;
    color: #8c939d;
    width: 158px;
    height: 88px;
    line-height: 102px;
    text-align: center;
}
.avatar-box{
    border-radius: 6px;
    border: 1px dashed #d9d9d9;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .el-icon-refresh-left{
        font-size: 30px;
        color: hsla(0,0%,100%,.85);
    }
    .shade{
        border-radius: 6px;
        background-color: rgba(0,0,0,.5);
        content: " ";
        height: 100%;
        opacity: 0;
        position: absolute;
        transition: all .3s;
        width: 100%;
        z-index: 1;
    }
    .content{
        position: absolute;
        z-index: 2;
        opacity: 0;
        transition: all .3s;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .upload-size{
            color: hsla(0,0%,100%,.85);
        }
    }
    &:hover{
        .shade,.content{
            opacity: 1;
        }
    }
}
.avatar {
    width: 160px;
    height: 130px;
    display: block;
    border-radius: 6px;
}
.avatar-uploader  .upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    &:hover{
        .upload-size,.avatar-uploader-icon{
            color: #409EFF;
        }
    }
}
</style>



// WEBPACK FOOTER //
// website/subComponents/sdkUpload.vue